// extracted by mini-css-extract-plugin
export var menuIcon = "_qp-0";
export var menuIconInline = "_qp-1";